import React, { useState, useMemo, useContext } from "react";
import { Redirect, useHistory } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { deleteCeecampaignFile, downloadFile } from "services/ConfigServices";
import useElementfilesTable from "./useElementfilesTable.js";
import EditElementfilesDialog from "./EditElementfilesDialog";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import UserService from "services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { ceecampaignfiles } from "variables/cee";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import { CEECampaignsContext } from "context/CEECampaignsContext";


const ElementDataDownload = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
  cursor: pointer;
  text-decoration: underline;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;


const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);


const downloadGED = (fileId, fileName) => async () => {
  axios
    .get(
      downloadFile(fileId),
      {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      }
    )
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
};


const useStyles = makeStyles(styles);

const RTElementfiles = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const ceeCampaignContext = useContext(CEECampaignsContext);
  const { ceecampaign } = ceeCampaignContext;
  const ceeadmin = permis.includes("cee_admin") && ceecampaign.ceecampaignAdminVisibility;
  const { gridState, refetch, setSelectedElementFiles } = useElementfilesTable();
  
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { groupInfoListById, setPage } = advancedSearchContext;
  const [open, setOpen] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const [currentFile, setCurrentFile] = useState(null);

  let dataFiles = gridState.data;

  const classes = useStyles();

  const columns = [
    {
      name: ceecampaignfiles.doctype,
      selector: (row) => row.parameters.doctype,
      sortable: true,
      maxWidth: "13rem",
    }, 
    {
      name: ceecampaignfiles.docname,
      selector: (row) => row.parameters.docname,
      sortable: true,
      maxWidth: "13rem",
    },
    {
      name: ceecampaignfiles.associatedfiles,
      selector: row => row.parameters.associatedfiles,
      sortable: true,
      cell: (row) => <ElementDataDownload
        onClick={downloadGED(row.parameters?.associatedfiles.fileId, row.parameters?.associatedfiles.fileName)}> {row.parameters?.associatedfiles.fileName}
      </ElementDataDownload>,
       maxWidth: "13rem",
    },
    {
      name: ceecampaignfiles.description,
      selector: (row) => row.parameters.description,
      sortable: true,
    },
    {
      name: "",
      sortable: false,
      width: "10rem",
      cell: (row) => (
        <>
          <div className="actions-right">
          {ceeadmin && (
              <>
            <Tooltip title="Editer la pièce">
              <Button
                onClick={editFile(row)}
                color={"warning"}
                className={classes.actionButton}
              >
                <EditIcon fontSize="large" />
              </Button>
            </Tooltip>
            
              <Tooltip title="Supprimer la pièce">
                <CustomDeleteButton
                  deleteTitle={"Suppression de la pièce"}
                  deleteSubTitle={`Êtes-vous sûr de vouloir supprimer la pièce?`}
                  handleSupprimer={deleteFileFunction(row)}
                />
              </Tooltip>
              </>
            )}
          </div>
        </>
      ),
    },
  ];

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const handleClickStatusOpen = () => {
    setOpenStatus(true);
  };
  const handleEditStatusClose = () => {
    setOpenStatus(false);
  };

  const editFile = (row) => async () => {
    let obj = dataFiles.find((o) => o.id === row.id);
    if (obj) {
      setCurrentFile(obj);
      handleClickOpen();
    }
  }

  const deleteFileFunction = (row) => async () => {
    let obj = dataFiles.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let url = deleteCeecampaignFile(idSelected);
    axios
      .delete(url, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `L'élément' '${obj.parameters.name} a été supprimé`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    setSelectedElementFiles(selection.selectedRows);
  };
  
  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noDataComponent={<NoData>Aucun élément à afficher</NoData>}
        noHeader={true}
        columns={columns}
        persistTableHead
        pagination
        subHeader
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleEditClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={open}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClose}>
          Modification de l'élément
        </CustomDialogTitle>
        <DialogContent dividers>
          <EditElementfilesDialog
            marketfile={currentFile}
            closeModal={handleEditClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RTElementfiles;
